export default __webpack_public_path__ + "static/media/GPImage.ac3d9783.png";